import axios from "axios";
import router from '../router'

const types = {
  SET_CITY: "SET_CITY",
  SET_CITY_OPTIONS: "SET_CITY_OPTIONS",
  SET_CITY_ARRAY: "SET_CITY_ARRAY",
  SET_REFERENCE: "SET_REFERENCE",
  SET_LINK_LOCATION: "SET_LINK_LOCATION",
  SET_LINK_INFORMATION: "SET_LINK_INFORMATION",
  SET_LINK_DIAV: "SET_LINK_DIAV",
  SET_LINK_BUENFIN: "SET_LINK_BUENFIN",
  SET_LINK_AVISO: "SET_LINK_AVISO",
  SET_LINK_INICIO: "SET_LINK_INICIO",
  SET_LINK_LOGO: "SET_LINK_LOGO",
  SET_POPUPS: "SET_POPUPS",
  SET_OPEN_MODAL: "SET_OPEN_MODAL",
  SET_SLIDERS: "SET_SLIDERS",
  SET_VIDA_WITH: "SET_VIDA_WITH",
  SET_VIDA_WITHOUT: "SET_VIDA_WITHOUT",
  SET_CITIES: "SET_CITIES",
  SET_PHONES: "SET_PHONES",
};

const state = {
  openPopup: false,
  popups: [],
  imagen: "",
  sliders: [],
  referenceStore: '',
  logo: '',
  vida: [],
  link_location: '/location',
  link_information: '/informes',
  link_inicio: '/inicio',
  link_diav: '/quejas-y-sugerencias',
  link_buenfin: '/buen-fin',
  link_aviso: '/aviso_de_privacidad',
  city_options: {
    name: "",
    niveles: [],
    facebook: {
      colegio: "",
      cipress: ""
    },
    informes: {
      domicilio2: "",
      domicilio: "",
      telefonos: []
    },
   preescolar: [],
   primaria: [],
   secundaria: [],
   preparatoria: [],
  },
  cities: [],
  cities2: [],
  city_selected: "",
  campus: [],
  level: "",
  campus_selected: {}
};

const actions = {
  setCity({ commit }, city) {
    commit(types.SET_CITY, city);
  },
  setCityOptions({ commit }, cityOptions) {
    commit(types.SET_CITY_OPTIONS, cityOptions);
  },
  setCityArray({ commit }, cityArray) {
    commit(types.SET_CITY_ARRAY, cityArray);
  },
  setReference({ commit }, reference) {
    commit(types.SET_REFERENCE, reference);
  },
  setLinkInformation({ commit }, value) {
    commit(types.SET_LINK_INFORMATION, value);
  },
  setLinkDiav({ commit }, value) {
    commit(types.SET_LINK_DIAV, value);
  },   
  setLinkBuenfin({ commit }, value) {
    commit(types.SET_LINK_BUENFIN, value);
  },  
  setLinkAviso({ commit }, value) {
    commit(types.SET_LINK_AVISO, value);
  },
  setLinkLocation({ commit }, value) {
    commit(types.SET_LINK_LOCATION, value);
  },
  setLinkInicio({ commit }, value) {
    commit(types.SET_LINK_INICIO, value);
  },
  setLogo({ commit }, value) {
    commit(types.SET_LINK_LOGO, value);
  },
  setModalImagen({ commit, dispatch }, data) {
      commit(types.SET_OPEN_MODAL, data);
  },    
  setPopups({ commit, dispatch }, data) {
    commit(types.SET_POPUPS, data);
  },    
  setSliders({ commit, dispatch }, data) {
      commit(types.SET_SLIDERS, data);
  },
  bindCampus({ commit, dispatch }, data) {
        console.log(state.vida)
        var campus_selected = data.campus_selected

        state.campus_selected = campus_selected;
        var isredirect = data.isredirect
        dispatch("setCity", campus_selected.id);
        var niveles = [];

        commit(types.SET_CITY_OPTIONS, campus_selected);
        commit(types.SET_LINK_DIAV, "/" + campus_selected.link + "/quejas-y-sugerencias");
        commit(types.SET_LINK_BUENFIN, "/" + campus_selected.link + "/buen-fin");
        commit(types.SET_LINK_LOCATION, "/" + campus_selected.link + "/ubicacion");
        commit(types.SET_LINK_AVISO, "/" + campus_selected.link + "/aviso_de_privacidad");
        commit(types.SET_LINK_INICIO, "/" + campus_selected.link + "/inicio");
        if(state.city_options.preescolar!=null){
            niveles.push({ text: "Preescolar", route: "/"+campus_selected.link+"/preescolar", original: "/preescolar" })
        }
        if(state.city_options.primaria!=null){
            niveles.push({ text: "Primaria", route: "/"+campus_selected.link+"/primaria", original: "/primaria" })
        }
        if(state.city_options.secundaria!=null){
            niveles.push({ text: "Secundaria", route: "/"+campus_selected.link+"/secundaria", original: "/secundaria" })
        }
        if(state.city_options.preparatoria!=null){
            niveles.push({ text: "Preparatoria", route: "/"+campus_selected.link+"/preparatoria", original: "/preparatoria" })
        }
        _.forEach(state.vida, function (value) {
            value.route = "/" + campus_selected.link + value.original
        });
        campus_selected.niveles = niveles;
        if(isredirect){
            router.push("/" + campus_selected.link + "/inicio/");
        }
    },
  getFeedData({ commit, dispatch }, data) {
    var link = data.link
    console.log(link)
    if(link=='aniversario-vizcaya' || link=='dia-estudiante' || link == "informes" || link == "inscripciones" || link == "gracias-informes"){
      link='';
    }
    var isredirect = data.isredirect
    var self = this
    axios({
      method: "get",
      url: "https://adminuva.tidingo.com/api/data-colegio?link_campus="+link,
      config: {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        },
        withCredentials: true,
        credentials: "same-origin"
      }
    }).then(function(response) {
        var data = response.data.data;
        if (
          data.popups.length > 0 && window.location.pathname == "/"
        ) {
          dispatch("setModalImagen", true);
          dispatch("setPopups", data.popups);
        }
        dispatch('setSliders',data.sliders)
        var campus = data.campus
        commit(types.SET_CITIES, campus);
        var formData = {"campus_selected": data.campus_selected, "isredirect":isredirect}
        if(data.campus_selected.link == 'Tepic' || data.campus_selected.link == 'Torreon' || data.campus_selected.link == 'Monclova' || data.campus_selected.link == 'Saltillo' || data.campus_selected.link == 'Piedras-negras'){
          commit(types.SET_VIDA_WITH, [ { title: "Artículos y eventos", route: "/eventos", original: "/eventos" }, { title: "RAPACES", route: "/rapaces", original: "/rapaces" }, { title: "National Geographic Learning", route: "/national-geographic", original: "/national-geographic" }]);
        }else{
          commit(types.SET_VIDA_WITHOUT, [ { title: "Artículos y eventos", route: "/eventos", original: "/eventos" }, { title: "RAPACES", route: "/rapaces", original: "/rapaces" }]);
        }
        state.campus_selected = formData;
        dispatch('bindCampus',formData)
    }).catch(function(error) {});
  },  
  getFeedDataPhones({ commit, dispatch }, data) {
    var self = this
    axios({
      method: "post",
      data: data,
      url: "https://adminuva.tidingo.com/api/data-colegio-phones",
      config: {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        },
        withCredentials: true,
        credentials: "same-origin"
      }
    }).then(function(response) {
        var data = response.data.data;
        commit(types.SET_PHONES, data);
    }).catch(function(error) {});
  },
};

const mutations = {
  [types.SET_CITY](state, city) {
    state.city_selected = city;
  },
  [types.SET_CITY_OPTIONS](state, cityOptions) {
    state.city_options = cityOptions;
  },
  [types.SET_CITY_ARRAY](state, cityArray) {
    state.cities = cityArray;
  },
  [types.SET_VIDA_WITH](state, val) {
    state.vida = val;
  },
  [types.SET_VIDA_WITHOUT](state, val) {
    state.vida = val;
  },
  [types.SET_REFERENCE](state, reference) {
    state.referenceStore = reference;
  },
  [types.SET_LINK_LOCATION](state, value) {
    state.link_location = value;
  },  
  [types.SET_LINK_DIAV](state, value) {
    state.link_diav = value;
  },    
  [types.SET_LINK_BUENFIN](state, value) {
    state.link_buenfin = value;
  },  
  [types.SET_LINK_AVISO](state, value) {
    state.link_aviso = value;
  },
  [types.SET_LINK_INICIO](state, value) {
    state.link_inicio = value;
  },
  [types.SET_LINK_INFORMATION](state, value) {
    state.link_information = value;
  },
  [types.SET_LINK_LOGO](state, value) {
    state.logo = value;
  },
  [types.SET_POPUPS](state, data) {
    state.popups = data;
  },   
  [types.SET_OPEN_MODAL](state, data) {
      state.openPopup = data;
  }, 
  [types.SET_CITIES](state, data) {
      state.campus = data;
      state.cities = data;
  },   
  [types.SET_SLIDERS](state, data) {
      state.sliders = data;
  },   
  [types.SET_PHONES](state, data) {
      state.city_options.telefonos = data;
  } 
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
